import { render } from "./PromSuggestions.vue?vue&type=template&id=2dd920f5"
import script from "./PromSuggestions.vue?vue&type=script&lang=js"
export * from "./PromSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__